import { getComponentKey } from 'utils/getComponentKey'
import * as common from 'store/modules/common'

import { api } from './api'

export const prefix = 'winesInStock'

export { api }
export const initialState = {
  gridKey: getComponentKey()
}
export const actionTypes = {
  refresh: `${prefix}/${common.suffix.refresh}`
}
export const actionCreators = {
  refresh: () => ({
    type: actionTypes.refresh
  }) 
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    default: return common.reducer(state, action, prefix)
  }
}

